import React from 'react';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { jsx as ___EmotionJSX } from "@emotion/core";
var FlagAsInappropriateLink = _ref => {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Report this listing' : _ref$text,
    href = _ref.href;
  var _useAllhomesApi = useAllhomesApi(),
    getAbsoluteUrl = _useAllhomesApi.getAbsoluteUrl;
  return ___EmotionJSX("a", {
    className: "allhomes-listing-details__flag-as-inappropriate-link",
    rel: "noopener noreferrer nofollow",
    target: "_blank",
    href: getAbsoluteUrl(href)
  }, ___EmotionJSX("span", {
    className: "allhomes-listing-details__flag-as-inappropriate-link-icon"
  }, "!"), ___EmotionJSX("span", {
    className: "allhomes-listing-details__flag-as-inappropriate-link-text"
  }, text));
};
export default FlagAsInappropriateLink;